import * as React from "react"
import { SaDefaultHeader } from "./saDefaultHeader"
// @ts-ignore
import { saDefaultHeaderSection } from './saDefaultHeader.module.scss'
import { saInterfaceDefaultSection } from "../saTypes"

export const SaDefaultHeaderContainer: React.FC<saInterfaceDefaultSection> = ({...props}) => {


  return (
    <section id={'saDefaultHeaderSection'}
             className={saDefaultHeaderSection}
    >
      <SaDefaultHeader {...props} />
    </section>
  )

}